<div class="return-title stagger-item" style="--anim-delay: 0ms">
  <div class="return-icon">
    <app-centrui-icon (click)="emitBack()" [file]="'ic-chevron-left.svg'" [svgStyle]="{'stroke': 'transparent', 'fill': '#1E31BF'}"></app-centrui-icon>
  </div>
  <span>{{title}}</span>
</div>

<div class="lumi-chat">
    <div class="lumi-chat-messages-wrapper">
    <div class="lumi-chat-messages" [class.hide-scrollbar]="feedbackOverlayVisible" #messagesContainer (scroll)="onMessagesScroll()" (wheel)="onMessagesWheel($event)">
      <div class="lumi-chat-loading-older" *ngIf="loadingOlderMessages">
        <app-centrui-spinner [sizeInRem]="1.25"></app-centrui-spinner>
      </div>
      <div class="lumi-chat-loading-history" *ngIf="loadingHistory">
        <app-centrui-spinner [sizeInRem]="2"></app-centrui-spinner>
      </div>
      <app-lumi-chat-message
        *ngFor="let msg of messages; let i = index"
        [message]="msg"
        [sourceNavigationProjectId]="sourceNavigationProjectId"
        [sourceNavigationProjectSlug]="sourceNavigationProjectSlug"
        [showThankYou]="!!msg.showFeedback && feedbackThankYouVisible"
        [thankYouFadingOut]="feedbackThankYouFadingOut"
        [style.--anim-delay]="getStaggerDelay(i)"
        (upvote)="onMessageUpvote(msg)"
        (downvote)="onMessageDownvote(msg)"
        (dismissThankYou)="hideThankYou()"
      ></app-lumi-chat-message>
    </div>
    <div class="lumi-chat-messages-blur" *ngIf="feedbackOverlayVisible"></div>
  </div>

  <div class="lumi-chat-input-wrapper" *ngIf="!feedbackOverlayVisible">
    <div class="lumi-chat-input">
      <textarea #messageInput
        rows="1"
        placeholder="Ask your question?"
        (input)="autoGrow($event)"
        (keydown.enter)="onEnterKey($event)"
      ></textarea>
      <button class="lumi-chat-send-btn" [disabled]="!messageInput.value.trim() || isStreaming" (click)="sendMessage()">
        <app-centrui-icon [file]="'new/sent.svg'"></app-centrui-icon>
      </button>
    </div>
  </div>

  <div class="lumi-chat-feedback-overlay" *ngIf="feedbackOverlayVisible">
    <div class="lumi-chat-feedback-overlay-input">
      <textarea #feedbackInput
        rows="3"
        placeholder="Please provide some feedback here..."
        [(ngModel)]="feedbackText"
      ></textarea>
      <hr class="lumi-chat-feedback-overlay-divider">
      <div class="lumi-chat-feedback-overlay-actions">
        <app-centrui-tag [text]="'SKIP'" [style]="'amethyst'" (clicked)="skipFeedback()"></app-centrui-tag>
        <button class="lumi-chat-feedback-send-btn" [disabled]="!feedbackText.trim()" (click)="submitFeedback()">
          <app-centrui-icon [file]="'new/sent.svg'" [svgStyle]="{'fill': '#1E31BF'}"></app-centrui-icon>
        </button>
      </div>
    </div>
    <p class="lumi-chat-feedback-overlay-note">Your feedback is always anonymous. When submitted from a project, only the project context is included to help improve accuracy and responses.</p>
  </div>

</div>
